import React, { Component } from 'react';
import YearbookPage from '../../components/YearbookPage';

class YearbookPageContainer extends Component {
  render() {
    return <YearbookPage />;
  }
}

export default YearbookPageContainer